export enum AdminRole {
  SuperAdmin = 'SUPER_ADMIN',
  OperationAdmin = 'OPERATION_ADMIN',
  StoreManager = 'STORE_MANAGER',
  StoreStaff = 'STORE_STAFF',
  Finance = 'FINANCE',
  CustomerService = 'CUSTOMER_SERVICE',
}

export const Permission = {
  All: '*',
  DashboardView: 'dashboard:view',
  DashboardEdit: 'dashboard:edit',
  OrderView: 'order:view',
  OrderEdit: 'order:edit',
  RefundView: 'refund:view',
  RefundEdit: 'refund:edit',
  StoreView: 'store:view',
  StoreEdit: 'store:edit',
  ProductView: 'product:view',
  ProductEdit: 'product:edit',
  DeliveryView: 'delivery:view',
  DeliveryEdit: 'delivery:edit',
  DroneView: 'drone:view',
  DroneEdit: 'drone:edit',
  UserView: 'user:view',
  UserEdit: 'user:edit',
  MemberView: 'member:view',
  MemberEdit: 'member:edit',
  MarketingView: 'marketing:view',
  MarketingEdit: 'marketing:edit',
  DataView: 'data:view',
  DataEdit: 'data:edit',
  FinanceView: 'finance:view',
  FinanceEdit: 'finance:edit',
  ProfitSharingView: 'profit_sharing:view',
  ProfitSharingManage: 'profit_sharing:manage',
  ProfitSharingExecute: 'profit_sharing:execute',
  MessageView: 'message:view',
  MessageEdit: 'message:edit',
  SystemView: 'system:view',
  SystemEdit: 'system:edit',
  SystemRoleView: 'role:view',
  SystemRoleEdit: 'role:edit',
} as const

export type PermissionCode = (typeof Permission)[keyof typeof Permission]
